import Profile from '../Images/About/about-photo.jpg';

function About() {
    return(
        <div>
            <br/><br/>
            <img className="hidden-xs hidden-sm" alt="Profile" style={{width:"50%", padding: "24px", margin:"auto"}} src={Profile} />
            <img className="visible-xs visible-sm" alt="Profile" style={{width:"100%"}} src={Profile} />
            <h5 className='page-text hidden-xs hidden-sm' style={{fontSize:"175%"}}>
                <br/>

                Hello everyone! I am Jackie, the proud owner of this small LGBTQ+ home bakery! 
                Baking is more than just a hobby, it's my way of spreading joy through delicious tasty treats! 
                All of my baked goods are made from scratch with so much love. 
                Please don't hesitate to reach out with any questions or custom requests by filling out the <a href='/contact'>Contact form here</a>. 
                I look forward to baking for you!
                <br/><br/>
                You can also find my Instagram here
                <br/>
                <a href='https://instagram.com/jackiesdoughandco'>@jackiesdoughandco</a>
                <br/><br/>
            </h5>

            <h5 className='page-text visible-xs visible-sm'>
                <br/>
                Hello everyone! I am Jackie, the proud owner of this small LGBTQ+ home bakery! 
                Baking is more than just a hobby, it's my way of spreading joy through delicious tasty treats! 
                All of my baked goods are made from scratch with so much love. 
                Please don't hesitate to reach out with any questions or custom requests by filling out the <a href='/contact'>Contact form here</a>. 
                I look forward to baking for you!
                <br/><br/>
                You can also find my Instagram here
                <br/>
                <a href='https://instagram.com/jackiesdoughandco'>@jackiesdoughandco</a>
                <br/><br/>
            </h5>
        </div>
    )
}
export default About;